<template>
<div class="header-bg">
    <div class="header"  @mouseleave="showProduct=false">
        <div class="logo">
            <img src="../../images/logo240.png"/>
        </div>
        <div class="menu">
            <ul>
                <li><router-link to="/" >首页</router-link></li>
                <li><a href="/shipping" >发货</a></li>
                <li><a href="/warehouse">仓储</a></li>
                <li><a href="/aboutus">关于我们</a></li>
                <li><a href="/recruit">人才招聘</a></li>
                <li><a href="/contactus">联系我们</a></li>
                <li>
                    <a href='http://order.xingyunyi.cn/' target="_blank"
                        @mouseover="u='2'"
                        @mouseout="u=''"
                            class="login">
                        <img :src="'/static/images/user'+u+'.png'" />
                        登陆
                    </a>
                    <a href='https://order.xingyunyi.cn/register' target="_blank"
                        @mouseover="o='2'"
                        @mouseout="o=''"
                            class="login">
                        <img :src="'/static/images/register'+o+'.png'" />
                        注册
                    </a>
                </li>
            </ul>
            <a class="hotline">
                <div class="left">
                    <img src="../../images/hotline.png" width="29" height="29" alt="广州行运易国际供应链有限公司">
                </div>
                <div>
                    <h6>行运易服务热线</h6>
                    <p class="phone">
                        400-993-2885
                    </p>
                </div>
            </a>
            <!-- <a href='http://order.xingyunyi.cn/' target="_blank"
                @mouseover="u='2'"
                @mouseout="u=''"
                    class="login">
                <img :src="'/static/images/user'+u+'.png'" />
                登陆
            </a> -->
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'xyy-header',
  data () {
    return {
      showProduct: false,
      i1: '',
      i2: '',
      i3: '',
      u: '',
      o: ''
    }
  }
}
</script>
<style scoped>
    .header-bg{background: #ffffff;box-shadow:1px 2px 14px -2px rgb(0 0 0 / 10%)}
    .header{ height:90px;top:0px;width:1300px;margin:0 auto; position: relative;}
    .logo{
        float:left;
        width: 200px;
        height:90px;
    }
    .logo img{
        height:80px;
        margin-top:5px
    }
    .menu{
        float:right;
        width:calc(100% - 240px);
        margin-right: 20px;
        overflow: hidden;
    }
    .menu ul{
        padding: 0px;
        margin: 0px;
        display: block;
        /* width: 580px; */
    }
    .menu li{
        display: block;
        width: auto;
        float: left;
        margin-right: 40px;
    }
    .menu li a{
        font-size: 18px;
        line-height: 90px;
    }
    a{
        color: #10499f ;
        font-family: "Montserrat", "Microsoft YaHei", "PingFang SC","NotoSansSC", "Microsoft JhengHei", Arial;
        text-decoration: none;
        padding-bottom: 12px;
    }
     a:hover{
        color:#074d74;
    }
    .login{
        display: inline-block;
        width:85px;
        height: 35px;
        margin-right: 10px;
        /* margin-right: 40px; */
        line-height: 32px !important;
        font-size: 14px !important;
        border-radius: 10px;
        margin-top: 28px;
        /* float:right; */
        background-color: #ebebeb;
        /* background-image: url("../../images/user.png"); */
        background-position-x:5px 0 0 10px;
        text-align: center;
        padding-bottom: 0;
    }

    .login img{
        width:16px;
        height: 16px;
        vertical-align: middle;
    }

    .login:hover {
        background: #074d74;
        color:#ffffff;
    }

    .login:hover a {
        color:#ffffff;
      }
    .login:hover a:hover {
        color:#ffffff;
      }

    .sub-menu{
        clear: both;
        border-top: 1px solid #ebebeb;
        height: 68px;
        background-color: #ffffff;
        width: 100%;
        top: 90px;
        position: absolute;
        z-index: 100;
    }
    .sub-menu ul{
        height: 68px;
        width: 410px;
        display: block;
        padding: 0;
        margin: 0 auto;
    }
    .sub-menu ul li{
        display: block;
        width: 100px;
        line-height: 68px;
        height: 68px;
        margin-left:30px;
        cursor: pointer;
        float: left;
    }

    .sub-menu ul li img{
        height: 24px;
        vertical-align: middle;
    }

    .sub-menu ul li a:hover{
        border-bottom:solid 3px #074d74;
    }

    .hotline {
        display: flex;
        align-items: center;
        height: 32px;
        float: right;
        margin-top: 30px;
    }
    .hotline h6, .hotline p {
        margin: 0;
        line-height: 1.2;
        font-size: 13px;
        color: #000000;
    }
    .hotline .left {
        display: flex;
        align-items: center;
        margin-right: 4px;
    }
    .hotline .phone {
        font-size: 18px;
        font-weight: 600;
        color: #012072;
    }

    @media screen and (max-width: 1326px) {
        .header {
            width: 1180px;
        }
    }
    @media screen and (max-width: 1150px) {
        .header {
            min-width: 1200px;
        }
        .login {
            margin-right: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/base/xyy-header.vue